import { create } from "zustand";
import type { User } from "../domain/models";
import { users } from "../mocks/data";

export type PageKey = "overview" | "services" | "service-detail" | "topology" | "instances" | "middleware" | "infrastructure" | "config" | "releases" | "logs" | "metrics" | "alerts" | "audit" | "users" | "settings";

interface OpsState {
  authenticated: boolean;
  currentUser?: User;
  activePage: PageKey;
  selectedServiceId: string;
  collapsed: boolean;
  login: (username: string, password: string) => boolean;
  logout: () => void;
  navigate: (page: PageKey) => void;
  openService: (serviceId: string) => void;
  setCollapsed: (collapsed: boolean) => void;
  canOperate: () => boolean;
}

export const useOpsStore = create<OpsState>((set, get) => ({
  authenticated: false,
  activePage: "overview",
  selectedServiceId: "svc-video",
  collapsed: false,
  login: (username, password) => {
    const user = users.find((item) => item.username === username && item.status === "active");
    const accepted = Boolean(user && password === "DevOps@2026");
    if (accepted) set({ authenticated: true, currentUser: user, activePage: "overview" });
    return accepted;
  },
  logout: () => set({ authenticated: false, currentUser: undefined }),
  navigate: (page) => set({ activePage: page }),
  openService: (serviceId) => set({ selectedServiceId: serviceId, activePage: "service-detail" }),
  setCollapsed: (collapsed) => set({ collapsed }),
  canOperate: () => get().currentUser?.roleId !== "role-viewer",
}));
